import { render } from "./ImageDropzone.vue?vue&type=template&id=1ceea586&scoped=true"
import script from "./ImageDropzone.vue?vue&type=script&lang=js"
export * from "./ImageDropzone.vue?vue&type=script&lang=js"

import "./ImageDropzone.vue?vue&type=style&index=0&id=1ceea586&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1ceea586"

export default script